import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function ActivityAnalyze() {
  const [itemObj, setItemObj] = useState({}); //設定當前點了table哪一筆tr物件(CRUD)
  const [action, setAction] = useState(""); //設定當前是做哪個動作(CRUD)
  const [actionIndex, setActionIndex] = useState(0);
  const [currentCompany, setCurrentCompany] = useState("");
  const [currentCbamMasterSeq, setCurrentCbamMasterSeq] = useState("");

  return (
    <Outlet
      context={{
        action,
        setAction,
        actionIndex,
        setActionIndex,
        itemObj,
        setItemObj,
        currentCompany,
        setCurrentCompany,
        currentCbamMasterSeq,
        setCurrentCbamMasterSeq,
      }}
    />
  );
}
